import React, { useContext, useState } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import MultiSelectBox from "../../../components/Forms/MultiSelectBox";
import { Form, Formik } from "formik";
import MultiLanguageInputText from "../../../components/Forms/MultiLanguageInputText";
import axios from "../../../config/axios";
import Input from "react-bootstrap-typeahead/types/components/Input";
import { DashboardContext } from "../../../routes/DashboardRoutes";

export default function TestDebugPage() {
  function submit(values) {
    console.log("values:", values);
  }

  const [identifier, setIdentifier] = useState(0);
  const { languages } = useContext(DashboardContext);

  const getBookings = async (params) => {
    return await axios.get(
      `/api/v1/bookings/${identifier}/lts_guest_passes.json`,
      { params: params }
    );
  };
  const handleClick = () => {
    getBookings({ booking_identifier_id: identifier });
  };
  const createGuestPass = async (params) => {
    //axios.post(`/api/v1/lts_guest_passes.json`, { booking_identifier_id: identifier, email: "luk.prister@gmail.com" });
    axios.post(
      `/api/v1/bookings/${identifier}/lts_guest_passes/create_and_update.json`,
      { booking_identifier_id: identifier, email: "goriha2151@edectus.com" }
    );
    //axios.post(`/api/v1/bookings/${identifier}/lts_guest_passes/new_create.json`, { booking_identifier_id: identifier, email: "test" });
  };
  const handleCreate = () => {
    createGuestPass();
  };
  const onChange = (e) => {
    const temp = e.target.value;
    setIdentifier(temp);
  };

  return (
    <Card>
      <Card.Body>
        <Card.Title>
          <b>Test Seite</b>
        </Card.Title>
        <Card.Text>Für Debugging Zwecke :)</Card.Text>
        <MultiSelectBox
          onChange={change}
          defaultValues={["blue", "yellow"]}
          label="Farbe"
          options={[
            { name: "Blau", value: "blue", color: "blue" },
            { name: "Rot", value: "red", color: "#e62e4d" },
            { name: "Gelb", value: "yellow" },
            { name: "Grün", value: "green" },
          ]}
          selectedValues={["blue", "yellow"]}
        />

        <h1>Multi Language Input Text</h1>
        <Formik initialValues={{}} onSubmit={submit}>
          {({ values }) => (
            <Form>
              <MultiLanguageInputText
                name={"description"}
                label={"Hello"}
                placeholder={"Beschreibung"}
                languages={languages}
              />

              <pre>{JSON.stringify(values, null, 2)}</pre>
              <Button type={"submit"}>Abschicken</Button>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  );
  return (
    <>
      <Row>
        <Col>
          <Input onChange={onChange} value={identifier}></Input>
        </Col>
      </Row>
      <Row>
        <Col>
          <Button onClick={handleCreate}>Create GuestPass</Button>
          <Button onClick={handleClick}>
            Get GuestPass for BookingIdentifier: {identifier}
          </Button>
        </Col>
      </Row>
    </>
  );
}
